import { Injectable } from '@angular/core';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TTripActualLocationDoc, TTripActualPosition } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class TripActualLocationService {
    private sequenceNumber = 0;
    private actualPositionsRunningTotal = 0;

    // private sessionService: SessionService,
    constructor(private firestoreService: FirestoreService,
        private firestorePathsService: FirestorePathsService) {
    }

    // public getObservable(): Observable<TTripActualLocationDoc> {
    //     const collection = this.firestorePathsService.getTripsPath();
    //     const observable = collection.valueChanges() as Observable<TTripActualLocationDoc>;
    //     return observable;
    // }

    public async getByUid(tripUid: string, actualLocationUid: string): Promise<any> {
        const path = this.firestorePathsService.getTripActualLocationPath(tripUid);
        return this.firestoreService.getByUid(path, actualLocationUid);
    }

    public async getAll(tripUid: string): Promise<TTripActualLocationDoc[]> {
        const path = this.firestorePathsService.getTripActualLocationPath(tripUid);
        return this.firestoreService.getAll(path) as Promise<TTripActualLocationDoc[]>;
    }

    // public add(tripUid: string, actualRoute: TTripActualLocation): Promise<TTripActualLocation> {
    //     const path = this.firestorePathsService.getTripActualLocationPath(tripUid);
    //     return this.firestoreService.add(path, actualRoute);
    // }

    public async set(tripUid: string, actualLocation: TTripActualLocationDoc): Promise<TTripActualLocationDoc> {
        const path = this.firestorePathsService.getTripActualLocationPath(tripUid);
        return this.firestoreService.set(path, actualLocation) as Promise<TTripActualLocationDoc>;
    }

    public async delete(tripUid: string, actualLocationUid: string): Promise<void> {
        const path = this.firestorePathsService.getTripActualLocationPath(tripUid);
        return this.firestoreService.delete(path, actualLocationUid);
    }

    public resetSeqeunceNumber() {
        this.sequenceNumber = 0;
    }

    public async addCurrentLocationToTrip(tripUid: string, legIdx: number,
        actualPositions: TTripActualPosition[]): Promise<TTripActualLocationDoc> {
        const sequenceNumber = ++this.sequenceNumber;
        this.actualPositionsRunningTotal += actualPositions.length;

        const actualLocation: TTripActualLocationDoc = {
            // dateTime: this.dateService.now(),
            // coordinate: vector.currentLocation,
            // speed: vector.speed,

            'sequenceNum': sequenceNumber,
            'legIndex': legIdx,
            'uid': sequenceNumber.toString(),
            'actualPositions': actualPositions
        };

        return this.set(tripUid, actualLocation);
    }

    public getActualPositionsRunningTotal(): number {
        return this.actualPositionsRunningTotal;
    }
}
